module.exports = __webpack_public_path__ + "img/ab.50d11969.jpg";